__turbopack_context__.v({
  "activeCircle": "stepbar-module-scss-module__mprA0a__activeCircle",
  "activeLine": "stepbar-module-scss-module__mprA0a__activeLine",
  "animatedCircle": "stepbar-module-scss-module__mprA0a__animatedCircle",
  "button": "stepbar-module-scss-module__mprA0a__button",
  "circle": "stepbar-module-scss-module__mprA0a__circle",
  "inactiveCircle": "stepbar-module-scss-module__mprA0a__inactiveCircle",
  "inactiveCircleContainer": "stepbar-module-scss-module__mprA0a__inactiveCircleContainer",
  "inactiveLine": "stepbar-module-scss-module__mprA0a__inactiveLine",
  "lastStepBlock": "stepbar-module-scss-module__mprA0a__lastStepBlock",
  "nextButton": "stepbar-module-scss-module__mprA0a__nextButton",
  "scaleUp": "stepbar-module-scss-module__mprA0a__scaleUp",
  "stepBlock": "stepbar-module-scss-module__mprA0a__stepBlock",
  "stepContainer": "stepbar-module-scss-module__mprA0a__stepContainer",
  "stepLabel": "stepbar-module-scss-module__mprA0a__stepLabel",
  "stepLine": "stepbar-module-scss-module__mprA0a__stepLine",
  "stepWrapper": "stepbar-module-scss-module__mprA0a__stepWrapper",
});
